import { motion } from 'framer-motion'
import styled from 'styled-components'
import { tablet } from '../../../../utils/mediaQueries'

// eslint-disable-next-line import/prefer-default-export
export const CardCandidateWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 16px 24px 16px 16px;
  gap: 16px;

  width: 40%;
  ${tablet({
    width: '95%',
  })};

  height: 184px;

  background: #ffffff;
  border: 1px solid #dae1fa;
  border-radius: 8px;

  .top {
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: flex-start;
    justify-content: space-between;
    height: 56px;

    .mag {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0px;
      gap: 15px;

      .logo {
        width: 56px;
        height: 56px;

        filter: drop-shadow(0px 3.70638px 7.41276px rgba(0, 0, 0, 0.08));
        border-radius: 11.1191px;
        object-fit: contain;
      }

      .jobName {
        font-family: 'Rubik';
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 22px;
        text-align: justify;
        color: #0d205f;
      }
    }
    .apply {
      width: 8px;
      height: 8px;
      display: inline-block;
      background: #faad14;
      border-radius: 50%;
    }
  }

  .main {
    .title {
      font-family: 'Rubik';
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 20px;
    }
  }

  .bottom {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    width: 100%;

    .candidateDate {
      font-family: 'Rubik';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      text-align: justify;
      font-feature-settings: 'salt' on, 'liga' off;

      color: #659dff;
    }

    .lastRow {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      padding: 0px;
      gap: 12px;
      width: 100%;

      .textWithIcon {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0px;
        gap: 4px;

        font-family: 'Rubik';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 32px;
        color: #0a1a4c;
      }
    }
  }
`
